<template>
   <f7-page name="deleted">
    <f7-navbar class="navbar-container">
            <f7-nav-center class="navbar-center">
                <div class="logo_text">
                    <div style="display: flex; justify-content: center;">
                        <img :src="logo">
                    </div>
                </div>
            </f7-nav-center>
        </f7-navbar>
    <div class="content">
        <img src="/static/images/icons/custom/sad-smile.svg" alt="sad smile">
        <h1>We’re sorry</h1>
        <slot></slot>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'deleted-page-component',
  computed: {
    ...mapState({
      logo: state => state.common.logo
    })
  }
}
</script>

<style scoped>
.page{
    background-color: #2C61D5;
    color: #fff;
}

.navbar-container{
    background-color: #fff;
}

.navbar-center{
    width: 100%;
}

.content > img {
    max-width: 110px;
    margin-bottom: 48px;
    opacity: 0.1;
}

.content {
    width: 100%;
    height: 100%;
    max-width: 788px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 102px 10% 30px;
    text-align: center;
}

.content > h1 {
    font-weight: 700;
    font-size: 44px;
    color: inherit;
}

.content > p {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// deleted-common.vue?377b9bb4